import { useEffect, useState } from "react";
import React from "react";

import {
  Col,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from "reactstrap";

import './Imagenes.css'
import SweetAlert from "react-bootstrap-sweetalert";


import { useDispatch, useSelector } from "react-redux";
import { informeImageList, informeImageDelete} from '../../../store/informeImage/actions'


const Imagenes = (props) => {
  const URL = process.env.REACT_APP_API_URL.split("/api").join("");
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(informeImageList())
  }, [dispatch])


  const InformeImage = useSelector(state=>state.InformeImage.informeImage.results)
  const state = useSelector(state=>state.InformeImage)
 

  const handleRemovoFoto = (foto) => {
    // props.InformeCopIma.splice(foto, 1);
    // previous()
    var cadena = "/media/" + foto.toString();
    const [InformaImageFilter] = cadena? InformeImage.filter(item=> item.image === cadena):null
    console.log(InformaImageFilter)
    dispatch(informeImageDelete(InformaImageFilter.id))
  };


  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === props.InformeCopIma.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? props.InformeCopIma.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const handleSlide = (newIndex) => {
    if (newIndex > activeIndex) {
      next();
    } else if (newIndex < activeIndex) {
      previous();
    }
  };

  const [model, setModel] = useState(false)
  const [tempimgsrc, setTempImgsrc]= useState('')

  const getImg = (imgSrc) => {
    setTempImgsrc(imgSrc)
    setModel(true)
  }
  const slides = props.Informe
    ? props.InformeCopIma.map((image, index) => (
        <CarouselItem
          key={index}
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
        >
          <Col >
            <div style={{ position: "relative" }}>
           
              <img
                src={`${URL}/media/${image}`}
                onClick={()=>{getImg(image) }}
                alt=""
                style={{
                  display: "block",
                  margin: "0 auto",
                  border: "2px dashed",
                  width: "150px",
                  height: "150px",
                  cursor:"pointer"
                }}
              />
     
              <button
              className="button-eliminar"
                onClick={() => {
                  handleRemovoFoto(image);
                }}
               
              >
                x
              </button>
              
            </div>
          </Col>
        </CarouselItem>
      ))
    : null;

  return (
    <React.Fragment>



{state.informeImageDeleted? (
        <SweetAlert
          title="Hecho!"
          success
          timeout={1000}
          showConfirm={false}
          onConfirm={() => {
           
            props.handleButtonClick();
          }}
        >
          Se ha eliminado la imagen
        </SweetAlert>
      ) : null}

    <div
    className={model? "model open":"model"}
    >
        <img src={`${URL}/media/${tempimgsrc}`} alt="" />
        <button 
        className="cerrar-foto"
        onClick={()=>{setModel(false)}}>X</button>
    </div>


      {props.Informe ? (
        <Carousel
          activeIndex={activeIndex}
          next={next}
          previous={previous}
          interval={false}
          className="carousel-margin"
        >
          <CarouselIndicators
            items={props.InformeCopIma}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
          />
          {slides}
          <CarouselControl
            className="carousel-back"
            direction="prev"
            directionText="Previous"
            onClickHandler={() => handleSlide(activeIndex - 1)}
          />
          <CarouselControl
            className="carousel-back"
            direction="next"
            directionText="Next"
            onClickHandler={() => handleSlide(activeIndex + 1)}
          />
        </Carousel>
      ) : null}
    </React.Fragment>
  );
};

export default Imagenes;
